import { DisclosureForm, DisclosureFormMode } from "./DisclosureForm";

export default function AddNewDisclosure() {
  return <DisclosureForm title="Add new disclosure" mode={DisclosureFormMode.ADD} />;
}
